/*
 * @Author: YuanYuan
 * @Date: 2024-02-05 10:17:49
 * @LastEditTime: 2026-03-24 20:17:51
 * @description: 全局统一方法
 */
import Clipboard from 'clipboard'
import i18n, { lang } from '@/i18n'
import $const from '@/constants'
import $store from '@/store'
import numeral from 'numeral'
import { find } from 'lodash-es'
import Cookies from 'js-cookie'
import CryptoJS from 'crypto-js'
import router from '@/router'
const { Message } = window.ELEMENT

export const getCurrentUser = () => Cookies.get('user') || (process.env.NODE_ENV==='development'?'':'')
export const getCurrentGoodsCode = () => Cookies.get('goods_code') || $store.state.csec.sessionScope?.goodsCode || 'csec-aps'
export const setCurrentGoodsGode = val => Cookies.set('goods_code', val)

export const sthFromLang = (cnW = 'cnName', enW = 'enName', jpW = 'enName', krW = 'enName') => {
  switch (lang) {
    case 'en_CN':
      return enW
    case 'ja-ip':
      return jpW || enW
    case 'ko-kr':
      return krW || enW
    default:
      return cnW
  }
}

export const routeTypeRadioWidth = sthFromLang(300, 380)

export const toPortalPath = path => {
  window.open(process.env.VUE_APP_PORTAL_URL + path, '_blank')
}

export const computedErrorMsg = responseData => {
  const retCodeEnum = $store.state.csec.waapDictMap.waap_retCodeEnum
  // 接口返回的code是数字，字典中的value是字符串，这里做一下格式统一处理
  const codeItem = retCodeEnum?.find(n => String(n.value) === String(responseData.code))
  if(codeItem) {
    return codeItem[sthFromLang()] || responseData.code
  } else {
    return responseData?.message || responseData?.msg || i18n.t('common.unkonwnError')
  }
}

export const numeralFormatter = (val, holder = '0') => {
  if (typeof val === 'number') {
    return val ? numeral(val).format('0,0') : holder
  } else if (typeof val === 'string') {
    if (val.includes('.')) {
      return val
    } else {
      if (typeof (val * 1) === 'number' && !isNaN(val * 1)) {
        return numeral(val * 1).format('0,0')
      } else {
        return val || holder
      }
    }
  } else if (val === undefined || val === null){
    return holder
  } else {
    return val?.toString() || holder
  }
}

export const toFixedFormatter = (val, to = 2, holder = '0.00') => {
  if (typeof val === 'number') {
    return numeral(val.toFixed(to)).format('0,0.00')
  } else if (typeof val === 'string') {
    if (typeof (val * 1) === 'number' && !isNaN(val * 1)) {
      return numeral((val * 1).toFixed(to)).format('0,0.00')
    } else {
      return val || holder
    }
  } else if (val === undefined || val === null) {
    return holder
  } else {
    return val.toString() || holder
  }
}

// 判断传入的path是否是完整地址，完整地址直接window打开，否则路由跳转
export const toMenuUrl = (menuItem) => {
  const isStringItem = typeof menuItem === 'string'
  const url = isStringItem ? menuItem : menuItem?.url
  if (!isStringItem && menuItem?.menuType === 'static') {
    goToStaticMenu(menuItem)
    // 前端静态菜单
  }else {
    // 后端动态菜单
   // window.location.href = url
    if (url) {
      if (url.startsWith('http')) {
        window.open(url, '_self')
      } else {
        window.open(window.location.origin + '/#' + url, '_self')
      }
    }
  }
}

export const filterMenus = leftMenuCode => {
  const allMenuData = $store.getters['csec/menuData']
  if (allMenuData.length) {
    const curGoodsCode = getCurrentGoodsCode()
    let menuList = allMenuData.find(n => n?.code === `${leftMenuCode}-${curGoodsCode}`)
    if (!menuList) {
      // 公共模块不需要添加商品码进行区别就采用统一的code，如费用中心Bills，账号管理User
      menuList = allMenuData.find(n => n?.code === leftMenuCode)
    }
    return menuList
  } else {
    console.warn('没有获取到菜单数据')
  }
}

const moduleFirstMenu = (leftMenuCode = 'Configurations') => {
  const leftMenuList = filterMenus(leftMenuCode)?.children
  if (leftMenuList?.length) {
    if (leftMenuList[0]?.children?.length) {
      return leftMenuList[0].children[0].url
    } else {
      return leftMenuList[0].url
    }
  } else {
    return ''
  }
}

// 跳转到第一个 leftMenuCode 菜单
export const toModuleFirstMenu = (leftMenuCode = 'Configurations') => {
  const url = moduleFirstMenu(leftMenuCode)
  if (url) {
    toMenuUrl(url)
  } else {
    Message.warning(`请先配置code为${leftMenuCode}的菜单`)
  }
}

/**
 * 将字符串转换为数组
 * @param str 字符串
 * @param sep 分隔符，默认为分号（;）
 * @param lineSep 是否换行分隔，默认为true
 * @returns 转换后的数组
 */
export const str2Arr = (str, lineSep = true, sep = ';') => {
  if (!str || str.constructor !== String) {
    return []
  }
  // 换行或sep分隔
  if (lineSep && sep) {
    const result = []
    const rowList = str.trim().split('\n')
    rowList.forEach(row => {
      const rowItemList = row ? row.split(sep) : []
      if (rowItemList.length) {
        rowItemList.forEach(n => {
          const trimStr = n.trim()
          trimStr && result.push(trimStr)
        })
      }
    })
    return result
  }
  // 只换行分隔
  if (lineSep && !sep) {
    const result = []
    const rowList = str.trim().split('\n')
    rowList.forEach(n => {
      const trimStr = n.trim()
      trimStr && result.push(trimStr)
    })
    return result
  }
  // 只分隔符分隔
  if (sep && str.includes(sep)) {
    const result = []
    const strList = str.trim().split(sep)
    strList.forEach(n => {
      const trimStr = n.trim()
      trimStr && result.push(trimStr)
    })
    return result
  }
  return [str.trim()]
}

export const downloadTxt = (txt, fileName = 'download.txt') => {
  const ele = document.createElement('a')
  ele.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(txt))
  ele.setAttribute('download', fileName)
  ele.style.display = 'none'
  document.body.appendChild(ele)
  ele.click()
  document.body.removeChild(ele)
}

export const downloadCsv = (txt, fileName = 'download') => {
  const BOM = '\uFEFF'
  const blob = new Blob([BOM + txt], { type: 'text/csv;charset=utf-8' })
  const url = window.URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = url
  a.download = fileName
  document.body.appendChild(a)
  a.click()
  document.body.removeChild(a)
  window.URL.revokeObjectURL(url)
}

// 复制到剪贴板
export const clip = (text, event) => {
  const clipboard = new Clipboard(event.target, {
    text: () => text
  })
  clipboard.on('success', () => {
    Message.success(i18n.t('common.copySuccess'))
    clipboard.destroy()
  })
  clipboard.on('error', () => {
    Message.error(i18n.t('common.copyFailed'))
    clipboard.destroy()
  })
  clipboard.onClick(event)
}

// 输入文件名，输出文件后缀
export const getFileExtension = fileName => {
  if (fileName) {
    const parts = fileName.split('.')
    return parts.pop()
  }
}

/**
 * 将数据格式化为带children属性的树形结构
 * @param {Array} data - 要格式化的数据数组
 * @param {string} key - 要转换为children的属性名
 * @returns {Array} 格式化后的树形结构数组
 * @description
 * 1. 如果数据为空返回空数组
 * 2. 递归遍历数组,将指定key的值转换为children属性
 * 3. 保留原对象的其他属性
 * @example
 * // 入参示例:
 * const data = [
 *   {
 *     id: 1,
 *     name: '父节点1',
 *     subList: [
 *       { id: 2, name: '子节点1' },
 *       { id: 3, name: '子节点2' }
 *     ]
 *   }
 * ]
 * formatToChildrenKey(data, 'subList')
 * // 出参示例:
 * [
 *   {
 *     id: 1, 
 *     name: '父节点1',
 *     children: [
 *       { id: 2, name: '子节点1' },
 *       { id: 3, name: '子节点2' }
 *     ]
 *   }
 * ]
 */
export const formatToChildrenKey = (data, key) => {
  if (!data?.length) return []
  return data.map(item => {
    if (item[key]) {
      return {
        ...item,
        children: formatToChildrenKey(item[key], key)
      }
    }
    return item
  })
}

/**
 * 将树形结构数据扁平化为一维数组
 * @param {Array} treeData - 树形结构数据
 * @param {string} childrenKey - children属性的key名
 * @returns {Array} 扁平化后的一维数组
 * @description
 * 1. 如果数据为空返回空数组
 * 2. 递归遍历树形数据,删除children属性
 * 3. 将所有节点放入同一层级的数组中
 * @example
 * // 入参示例:
 * const treeData = [
 *   {
 *     id: 1,
 *     name: '父节点1',
 *     children: [
 *       { id: 2, name: '子节点1' },
 *       { id: 3, name: '子节点2' }
 *     ]
 *   }
 * ]
 * simplizeTreeData(treeData, 'children')
 * // 出参示例:
 * [
 *   { id: 1, name: '父节点1' },
 *   { id: 2, name: '子节点1' },
 *   { id: 3, name: '子节点2' }
 * ]
 */
export const simplizeTreeData = (treeData, childrenKey = 'children') => {
  if (!treeData?.length) return []
  const result = []
  const traverse = data => {
    data.forEach(item => {
      const copyParent = { ...item }
      delete copyParent[childrenKey]
      result.push(copyParent)
      if (item[childrenKey]?.length) {
        traverse(item[childrenKey])
      }
    })
  }
  traverse(treeData)
  return result
}

// 判断 to 路由是否存在当前菜单中
export const isInMenuList = to => {
  if (to?.meta?.backable) {
    return true
  } else {
    const leftMenuList = filterMenus(to.meta.leftMenuCode)?.children
    if (leftMenuList?.length) {
      const simplizedMenuList = simplizeTreeData(leftMenuList)?.filter(n => !!n.url)
      const validUrls = simplizedMenuList.map(n => n.url)
      const curPath = (window.location.origin + '/' + window.location.hash)
      return validUrls.some(n => curPath.indexOf(n) > -1 || to.path.indexOf(n) > -1 || n.indexOf(to.path) > -1)
    } else {
      return true
    }
  }
}

// 对应 csec2.0 中的COMMON.parseProduceName()方法
export const findProductName = (productType, holder) => {
  const allProducts = $store.state.csec.productTypeList
  const cur = find(allProducts, { id: productType })
  return cur ? cur[sthFromLang('productName', 'productNameEn')] : (holder || productType)
}

export const getLabelFromList = (options, val, prop = 'value', cnLabelKey = 'cnName', enLabelKey = 'enName') => {
  try {
    if(options?.length) {
      const cur = options.find(n => n[prop] === val)
      return cur ? cur[sthFromLang(cnLabelKey, enLabelKey)] : val
    } else {
      return val
    }
  } catch (error) {
    console.warn(new Error('getLabelFromList: 出错啦'))
  }
}

const getLabelFromConst = (constName, value, prop) => {
  if (constName) {
    if (value !== undefined) {
      const obj = $const[constName]?.find(n => n.value === value)
      if (obj) {
        return obj[prop]
      } else {
        console.warn(new Error(`getLabelFromConst: ${value}不在${constName}常量中`))
        return value
      }
    } else {
      return value
    }
  } else {
    console.warn(new Error('getLabelFromConst: constName 不能为空'))
  }
}

/* 
  $constGet('Common/[name]', 1, 'colorClazz')
  返回常量 'Common/[name]' 项中 value === 1 时候对应的 colorClazz 属性值
  value 为 数组时 ，此时返回对应prop的数组
*/
export const constGet = (constName, value, prop = 'label') => {
  if (value instanceof Array) {
    if (value.length) {
      const resultList = value.map(n => {
        return getLabelFromConst(constName, n, prop)
      })
      return resultList
    } else {
      return []
    }
  } else if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') {
    return getLabelFromConst(constName, value, prop)
  } else if (value === '') {
    return getLabelFromConst(constName, value, prop)
  } else if (value === undefined || value === null) {
    return value
  } else {
    console.warn(new Error(`constGet: ${constName} 中找不到 ${value}，因为 value 只支持数组，字符串，布尔，数字类型`))
  }
}

export const initToLogin = () => {
  Cookies.set('X-Cms-Token', '')
  Cookies.remove('user')
  $store.commit('csec/INIT_STATE')
  router.replace('/login')
}

export const loginFromPath = () => {
  $store.commit('csec/SET_LOGIN_NEXT_ROUTE', router.currentRoute.path)
  router.replace('/login')
}

export const hourCountdownFormatter = sec => {
  let seconds = parseInt(sec) >= 0 ? parseInt(sec) : 0
  let minutes = 0
  let hours = 0
  if (seconds > 60) {
    minutes = parseInt(seconds / 60)
    seconds = parseInt(seconds % 60)
  }
  if (minutes > 60) {
    hours = parseInt(minutes / 60)
    minutes = parseInt(minutes % 60)
  }
  return `${hours}${i18n.t('common.hours')}${minutes}${i18n.t('common.minutes')}${seconds}${i18n.t('common.seconds')}`
}

export const dayCountdownFormatter = sec => {
  let seconds = parseInt(sec) >= 0 ? parseInt(sec) : 0
  let minutes = 0
  let hours = 0
  let days = 0
  if (seconds > 60) {
    minutes = parseInt(seconds / 60)
    seconds = parseInt(seconds % 60)
  }
  if (minutes > 60) {
    hours = parseInt(minutes / 60)
    minutes = parseInt(minutes % 60)
  }
  if (hours > 24) {
    days = parseInt(hours / 24)
    hours = parseInt(hours % 24)
  }
  return `${days}${i18n.t('common.dayss')}${hours}${i18n.t('common.hours')}${minutes}${i18n.t('common.minutes')}`
}

export const formatSumNumeral = (a, b, unit) => {
  const sum = Number(a || 0) + Number(b || 0)
  const sumNumeral = numeralFormatter(sum)
  const aNumeral = numeralFormatter(a)
  const bNumeral = numeralFormatter(b)
  return `${sumNumeral}${i18n.t('common.bracket', { name: `${aNumeral} + ${bNumeral}` })}${unit||''}`
}

const aesKeyStr = '7fca52a8-0e05-46'
const ivArr = [82, 98, 50, 3, -16, 124,-40, -114, -87, -40, 37, 23,-56, 23, -33, 75]

const javaBytesToWordArray = (javaBytes) => {
  // 将有符号byte转换为无符号的16进制字符串
  const hexString = javaBytes.map(b => {
      return (b & 0xFF).toString(16).padStart(2, '0');
  }).join('');
  
  return CryptoJS.enc.Hex.parse(hexString);
}

export const aesEncodePwd = (pwd, keyStr = aesKeyStr) => {
  if (!pwd) {
    return ''
  }
  const key = CryptoJS.enc.Utf8.parse(keyStr)
  const encrypted = CryptoJS.AES.encrypt(pwd, key, {
    iv: javaBytesToWordArray(ivArr),
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  })
  return encrypted.ciphertext.toString(CryptoJS.enc.Hex)
}

export const aesDecodePwd = (pwd, keyStr = aesKeyStr) => {
  if (!pwd) {
    return ''
  }
  const key = CryptoJS.enc.Utf8.parse(keyStr)
  const cipherParams = CryptoJS.lib.CipherParams.create({
    ciphertext: CryptoJS.enc.Hex.parse(pwd)
  })
  const decrypted = CryptoJS.AES.decrypt(cipherParams, key, {
    iv: javaBytesToWordArray(ivArr),
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  })
  return decrypted.toString(CryptoJS.enc.Utf8)
}

export const goToConsole = () => {
  if (getCurrentUser()) {
    toModuleFirstMenu()
  } else {
    router.replace('/login')
  }
}

// 切换菜单顶部当前商品
export const switchCurProduct = (val, refresh = true) => {
  const curGoodsCode = getCurrentGoodsCode()
  // 从后管跳转过来，cookie中没有商品code
  if (!Cookies.get('goods_code')) {
    setCurrentGoodsGode(val)
    window.location.reload()
  } else{
    if (val !== curGoodsCode) {
      setCurrentGoodsGode(val)
      if (refresh) {
        if(!ifRouterStay(window.location.href)) {
          const curHref = window.location.href.includes('?token=') ? window.location.href.split('?token=')[0] : window.location.href
          if (curHref === moduleFirstMenu()) {
            window.location.reload()
          } else {
            toModuleFirstMenu()
          }
        }else {
          window.location.reload()
        }
      }
    }
  }
}

const ifRouterStay = (url) => {
  const stayPath = $const['Common/ProductSwitcStaty']
  let flag = false
  for (const path of stayPath) {
    if(url.includes(path)) {
      flag = true
      break
    }
  }
  return flag
}

// 递归查找树形数据中的指定节点
export const findNode = (tree, predicate) => {
  for (const node of tree) {
    if (predicate(node)) return node;
    if (node.children) {
      const found = findNode(node.children, predicate);
      if (found) return found;
    }
  }
  return null;
}

export const hasPermission = (code, combine = 'OR') => {
  const allPermissions = $store.state.csec.permissionCodes
  const goodsCode = Cookies.get('goods_code')
  const prefix = `${goodsCode}:`
  const avail = allPermissions.filter(item => item.includes(prefix) || !item.includes(':')).map(item => {
    if (item.includes(':')) {
      return item.split(':')[1]
    }else {
      return item
    }
  })
  if (Array.isArray(code)) {
    if (combine === 'OR') {
      return code.length ? code.some(c => avail.includes(c)) : false
    }else if (combine === 'AND') {
      return code.length ? code.every(c => avail.includes(c)) : false
    }
  }else {
    return code ? avail.includes(code) : false
  }

}

/**
 * 静态菜单跳转
 * 菜单示例数据：
 * {
 *              nameCn: '安全策略',
 *              nameEn: 'Security Policy',
 *              url: `${process.env.VUE_APP_WAAP_URL}/index#/csec/domainProtection/securityPolicy/basic`,
 *              platform:'waap',
 *              code: 'domainProtection',
 *              menuType: 'static',
 *              permission:'EDIT_SINGLE_DOMAIN_SECURITY_POLICY'
 *            }
 *
 *            query: {
 *              domain: 'abc.com'
 *            }
 * */

export const goToStaticMenu = (menuItem) => {
  let url = menuItem.url
  // 拼接 query 参数
  /*if (query && typeof query === 'object' && Object.keys(query).length) {
    const queryStr = Object.entries(query)
      .map(([key, val]) => `${encodeURIComponent(key)}=${encodeURIComponent(val)}`)
      .join('&')
    url += (url.includes('?') ? '&' : '?') + queryStr
  }*/
  if (menuItem?.platform === 'waap') {
    const permissions = $store.state.csec.permissionCodes
    const urlCode = menuItem.code
    const productCode = getCurrentGoodsCode()
    const pageCode = `${productCode}_${urlCode}`
    const newUrl = url + (url.includes('?') ? '&' : '?') +
      `productCode=${productCode}&code=${pageCode}&permissions=${encodeURIComponent(permissions)}&domain=${$store.state.domainManage.pageDomain}`
    window.open(newUrl, '_self')
  } else {
    if (url) {
      if (url.startsWith('http')) {
        window.open(url, '_self')
      } else {
        window.open(window.location.origin + '/#' + url, '_self')
      }
    }
  }
}

